import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api/axios';
import toast from 'react-hot-toast';

const empty = {
  sub_county:'', ward:'', sub_ward:'', market:'', business_name:'',
  plot_no:'', trader_name:'', contact:'', nature_of_business:'',
  sbp_no:'', mr_no:'', mode_of_payment:'UNSPECIFIED', transaction_no:'',
  amount:0, issuing_officer:'',
};

export default function BusinessForm() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isEdit) api.get(`/businesses/${id}/`).then(r => setForm(r.data));
  }, [id, isEdit]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isEdit) {
        await api.put(`/businesses/${id}/`, form);
        toast.success('Business updated');
      } else {
        await api.post('/businesses/', form);
        toast.success('Business created');
      }
      navigate('/businesses');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error saving');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header"><h1>{isEdit ? 'Edit' : 'Add'} Business</h1></div>
      <div className="card">
        <form onSubmit={handleSubmit}>
          <h3 style={{marginBottom:'16px',color:'#1a5632'}}>Location</h3>
          <div className="form-grid">
            <div className="form-group"><label>Sub County</label><input name="sub_county" value={form.sub_county} onChange={handleChange} required /></div>
            <div className="form-group"><label>Ward</label><input name="ward" value={form.ward} onChange={handleChange} required /></div>
            <div className="form-group"><label>Sub Ward</label><input name="sub_ward" value={form.sub_ward} onChange={handleChange} /></div>
            <div className="form-group"><label>Market</label><input name="market" value={form.market} onChange={handleChange} required /></div>
          </div>

          <h3 style={{margin:'20px 0 16px',color:'#1a5632'}}>Business Details</h3>
          <div className="form-grid">
            <div className="form-group"><label>Business Name</label><input name="business_name" value={form.business_name} onChange={handleChange} /></div>
            <div className="form-group"><label>Plot No</label><input name="plot_no" value={form.plot_no} onChange={handleChange} /></div>
            <div className="form-group"><label>Trader's Name</label><input name="trader_name" value={form.trader_name} onChange={handleChange} /></div>
            <div className="form-group"><label>Contact</label><input name="contact" value={form.contact} onChange={handleChange} /></div>
            <div className="form-group"><label>Nature of Business</label><input name="nature_of_business" value={form.nature_of_business} onChange={handleChange} /></div>
          </div>

          <h3 style={{margin:'20px 0 16px',color:'#1a5632'}}>Payment Information</h3>
          <div className="form-grid">
            <div className="form-group"><label>SBP No</label><input name="sbp_no" value={form.sbp_no} onChange={handleChange} /></div>
            <div className="form-group"><label>MR No</label><input name="mr_no" value={form.mr_no} onChange={handleChange} /></div>
            <div className="form-group">
              <label>Mode of Payment</label>
              <select name="mode_of_payment" value={form.mode_of_payment} onChange={handleChange}>
                <option value="CASH">Cash</option>
                <option value="PAYBILL">Paybill</option>
                <option value="BANK">Bank</option>
                <option value="UNSPECIFIED">Unspecified</option>
              </select>
            </div>
            <div className="form-group"><label>Transaction No</label><input name="transaction_no" value={form.transaction_no} onChange={handleChange} /></div>
            <div className="form-group"><label>Amount (KES)</label><input type="number" name="amount" value={form.amount} onChange={handleChange} min="0" /></div>
            <div className="form-group"><label>Issuing Officer</label><input name="issuing_officer" value={form.issuing_officer} onChange={handleChange} /></div>
          </div>

          <div style={{display:'flex',gap:'12px',marginTop:'24px'}}>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Saving...' : isEdit ? 'Update Business' : 'Create Business'}</button>
            <button type="button" className="btn btn-outline" onClick={() => navigate('/businesses')}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
